export const IS_CONFIRM_DIALOG_OPEN = "IS_CONFIRM_DIALOG_OPEN"
export const SET_DIALOG_DATA = "SET_DIALOG_DATA"



// WEBPACK FOOTER //
// ./src/types/actions/confirm-dialog.js